import { useMemo } from "react";

import { ListInfo, useListInfo } from "./ListInfoProvider";

export type ListActionInfo = {
	selected: Array<string>;

	noneSelected: boolean;
	firstSelected: boolean;
	lastSelected: boolean;
};

export default function useListActionInfo(): ListActionInfo {
	const listInfo: ListInfo = useListInfo();

	const selectableElements = useMemo(
		() =>
			Object.entries(listInfo.elements).filter(
				element => element[1].enabled && element[1].visible
			),
		[listInfo.elements]
	);

	const selectedElements = useMemo(
		() => selectableElements.filter(element => element[1].selected),
		[selectableElements]
	);

	return useMemo(
		() => ({
			selected: selectedElements.map(element => element[0]),
			noneSelected: selectedElements.length === 0,
			firstSelected:
				selectableElements.length > 0 &&
				selectableElements[0]?.[1].selected,
			lastSelected:
				selectableElements.length > 0 &&
				selectableElements[selectableElements.length - 1][1].selected
		}),
		[selectedElements, selectableElements]
	);
}
